import { render, staticRenderFns } from "./collapseBox.vue?vue&type=template&id=2a42f16c&"
import script from "./collapseBox.vue?vue&type=script&lang=ts&"
export * from "./collapseBox.vue?vue&type=script&lang=ts&"
import style0 from "./collapseBox.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports